export enum DelegationFoodTypeEnum {
  None = 1,
  Partial = 2,
  Full = 3 
}